export default "__VITE_ASSET__BvmJlnBa__"